// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q2xv","textarea":"styles_textarea__2j4Jr"};